import React, { useState, useEffect } from "react"
import { makeStyles } from "@mui/styles"

import MainContainer from "../../components/MainContainer"
import MainHeader from "../../components/MainHeader"
import Title from "../../components/Title"
import SubscriptionModal from "../../components/SubscriptionModal"
import api from "../../services/api"

import { toast } from "react-toastify"

import config from "../../config/config.json"
import { Box, Tab, Tabs } from "@mui/material"
import UserSubscription from "./UserSubscription"
import PaymentList from "./Payments"

const useStyles = makeStyles({
    card: {
        maxWidth: 300,
        padding: "12px 8px",
        marginLeft: "auto",
        marginRight: "auto",
    },
    bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)",
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    titleContainer: {
        textAlign: "center",
        width: "100%",
        marginTop: "1rem",
        marginBottom: "2.225rem",
    },
})

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    }
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    )
}

const Invoices = () => {
    const classes = useStyles()
    const [subscription, setSubscription] = useState(null)

    const [storagePlans] = React.useState([])
    const [selectedContactId] = useState(null)
    const [contactModalOpen, setContactModalOpen] = useState(false)

    const [value, setValue] = React.useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const getSubscription = async () => {
        try {
            const response = await api.get("/subscription")

            if (response.status === 200) {
                if (response.data.subscription) {
                    setSubscription({
                        ...response.data.subscription,
                        plan: response.data.plan,
                    })
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getSubscription()
    }, [])

    const handleCancel = async () => {
        if (confirm("Tem certeza que deseja cancelar sua assinatura?")) {
            const response = await api.put(`/subscription/delete`, {
                id: subscription.id,
            })
            if (response.status === 200) {
                toast.warning(
                    `Você cancelou sua assinatura. Considere escolher um novo plano para continuar utilizando o ${config.system.name}`,
                )
                setSubscription(null)
            }
        }
    }

    return (
        <MainContainer>
            <SubscriptionModal
                open={contactModalOpen}
                onClose={() => {
                    setContactModalOpen(false)
                    getSubscription()
                }}
                aria-labelledby="form-dialog-title"
                Invoice={storagePlans}
                contactId={selectedContactId}
            />

            <MainHeader>
                <div className={classes.titleContainer}>
                    <Title>Assinatura</Title>
                </div>
            </MainHeader>

            <Box sx={{ width: "100%", overflow: "auto" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                    >
                        <Tab label="Minha assinatura" {...a11yProps(0)} />
                        <Tab label="Pagamentos" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <UserSubscription
                        subscription={subscription}
                        setContactModalOpen={setContactModalOpen}
                        handleCancel={handleCancel}
                    />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <PaymentList />
                </CustomTabPanel>
            </Box>
        </MainContainer>
    )
}

export default Invoices
